<template>
  <el-dialog title="消息" :visible.sync="visible" :before-close="close" width="90%" hight="80%">
  <div>
    <Layout>
      <Card>
        <div class="search-box" style="padding-bottom: 12px;">
          <div class="search-select-wraper">
            <div class="search-select-title">状态:</div>
            <Select
              v-model="tableparam.status"
              size="small"
              clearable
              placeholder="请选择"
              
            >
              <Option
                 v-for="(sta,i) in tableHandle.statusMsgMap.news"
                :key="i"
                :label="sta"
                :value="i"
              ></Option> 
           </Select>
          </div>
          <div class="search-select-wraper">
            <div class="search-select-title">时间段:</div>
            <Select
              v-model="searchDateType"
              size="small"
              clearable
              @on-change="searchDateTypeChange"
              placeholder="请选择"
              
            >
              <Option
                v-for="sta in tableHandle.searchDateTypes.news"
                :key="sta.value"
                :label="sta.label"
                :value="sta.value"
              ></Option> 
           </Select>
          </div>
          <el-date-picker
                v-model="searchDateStart"
                value-format="yyyy-MM-dd HH:mm:ss"
                width="100%"
                type="date"
                placeholder="开始时间"
            >
            </el-date-picker>
            <div class="space">--</div>
            <el-date-picker
                v-model="searchDateEnd"
                value-format="yyyy-MM-dd HH:mm:ss"
                width="100%"
                type="date"
                placeholder="结束时间"
            >
            </el-date-picker>
          
          
        </div>
        <div class="search-box">
          
          <div class="search-select-wraper">
            <div class="search-select-title">查询项:</div>
            <Select
              v-model="searchKeyType"
              size="small"
              clearable
              @on-change="searchKeyTypeChange"
              placeholder="请选择"
              
            >
              <Option
                v-for="sta in tableHandle.searchKeyTypes.news"
                :key="sta.value"
                :label="sta.label"
                :value="sta.value"
              ></Option> 
           </Select>
          </div>
          <Input
            v-model="searchKey"
            :placeholder="placeholder"
            search
            enter-button="搜索"
            :style="{ width: '350px' }"
            @on-search="tableQuery"
          />
          
        </div>
        
       <div v-if="inited" class="content">
        <el-table :data="tabledata" :height="tableHeight">
          <el-table-column prop="id" align="center" minWidth="80" label="编号"></el-table-column>
          <el-table-column align="center"  minWidth="100"  label="操作">
            <div slot-scope="scope" class="table-action">
              <template v-for="(action,index) in scope.row.tableActions">
               <div class="table-action-item" :key="'action'+index" @click="doAction(scope.row)">{{action.title}}<div class="table-action-item-pot" v-if="action.dot"></div></div>
              </template>
            </div>
          </el-table-column>
          <el-table-column prop="avatar" align="center" minWidth="80" label="客户头像">
            <template slot-scope="scope">
              <img :src="scope.row.avatar" @click="openUserBasicInfo(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column prop="orgName" align="center" minWidth="100" label="机构"></el-table-column>
          <el-table-column prop="teamName" align="center" minWidth="100" label="团队"></el-table-column>
          <el-table-column prop="doctorName" align="center" minWidth="100" label="咨询师"></el-table-column>
          <el-table-column prop="newsName" align="center" minWidth="100" label="消息时间"></el-table-column>
          <el-table-column prop="newsTime" align="center" minWidth="100" label="消息内容"></el-table-column>
          <el-table-column prop="processFlowDesc" align="center" minWidth="200" label="回复内容"></el-table-column>
          <el-table-column prop="status" align="center" minWidth="100" label="状态">
            <template slot-scope="{ row }">
                {{ tableHandle.statusMsgMap.news[row.status] }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="tableparam.page"
          :page-size="tableparam.pageSize"
          @current-change="handleCurrentChange"
          :total="tableparam.total"
        ></el-pagination>
        
      </div>
      </Card>
      
      
    </Layout>
  </div>
  </el-dialog>
</template>
<script>
import { api } from "@/request/api";
export default {
  props: ['visible','params'],
  components: {
    
  },
  data() {
    return {
      tableparam:{
        total: 0,
        page: 1,
        pageSize: 20,
        status: "",
      },
      tableHeight:100,
      inited:false,
      tabledata: [],
      revamp: false,
      formLabelWidth: "100px",
      placeholder:"",
      searchKey:"",
      searchDateStart:"",
      searchDateEnd:""
      
    };
  },
  mounted(){
    
  },
  created() {
    var that=this;
    that.$watch('visible', function() {
      Object.assign(that.tableparam, that.params);
      if(that.visible){
        that.initData();
      }
    });
    that.initSearchBar();
  },
  methods: {
    initData(){
      var that=this;
      that.defaultTable(that);
      that.tableQuery();
    },
    initSearchBar(){
      // var statusMsgMap=this.tableHandle.statusMsgMap.news;
      // this.tableparam.status=Object.keys(statusMsgMap)[0];
      var searchKeyType=this.tableHandle.searchKeyTypes.news[0];
      if(searchKeyType){
        this.placeholder=searchKeyType.placeholder;
        this.searchKeyType=searchKeyType.value;
      }
      else{
        this.placeholder="";
      }
      this.searchKey='';

      var searchDateType=this.tableHandle.searchDateTypes.news[0];
      if(searchDateType){
        this.searchDateType=searchDateType.value;
      }
      this.searchDateStart='';
      this.searchDateEnd='';
    },
    searchKeyTypeChange(){
      var that=this;
      var searchKeyType=that.tableHandle.searchKeyTypes.news.findWithKey('value',that.searchKeyType);
      if(searchKeyType){
        that.placeholder=searchKeyType.placeholder;
      }
      else{
        that.placeholder="";
      }
      that.searchKey='';
    },
    searchDateTypeChange(){
      var that=this;
      that.searchDateStart='';
      that.searchDateEnd='';
    },
    close(){
      this.$emit("close");
    },
    openUserBasicInfo(row){
      this.notificationCenter.postNotificationName('openUserBasicInfo',row);
    },
    doAction(row){
      this.notificationCenter.postNotificationName('openNewsDailog',row);
    },
    tableQuery() {
      console.log(8889);
      //列表
      var that = this;
      var parameter = {
        page: that.tableparam.page,
        status: that.tableparam.status,
        pageSize: that.tableparam.pageSize
      };
      if(that.searchKeyType){
        parameter[that.searchKeyType]=that.searchKey;
      }
      if(that.searchDateType){
        var searchDateType=that.tableHandle.searchDateTypes.news.findWithKey('value',this.searchDateType);
        parameter[searchDateType.start]=that.searchDateStart;
        parameter[searchDateType.end]=that.searchDateEnd;
      }
      api.messageQueryList(parameter).then((response) => {
        response = response.data;
        if (response.code == 0) {
          that.tableparam.total = response.page.totalCount;
          that.tabledata = response.page.list;
          for (var row in that.tabledata) {
            that.tableHandle.actions.news(that.tabledata[row]);
          }
        }
      });
    },
    handleCurrentChange(cpage) {
      //分页
      this.tableparam.page = cpage;
      this.tableQuery();
    },
  },
};
</script>
<style lang="less" scoped="scoped">
.okButton
{
  margin-left:10px;
}
.search-box {
  display: flex;
  .add-btn {
    margin-right: 10px;
  }
}
.content img {
  width: 40px;
}
.newkhdn {
  .el-date-editor.el-input {
    width: 100%;
  }
  .el-select {
    display: block;
  }

}
.table-action{
  display: flex;
  align-items: center;
  justify-content: center;
  
}
.table-action-item{
  
}
.table-action-item{
 position: relative;
 padding: 4px;
}
.table-action-item-pot{
  background: red;
    width: 4px;
    height: 4px;
    border-radius: 2px;
    position: absolute;
    top: 4px;
    right: 4px;
}
.search-select-wraper{
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-select-title{
  width: 100px;
}
/deep/.ivu-select{
  height: 100%;
}
/deep/.ivu-select-small.ivu-select-single .ivu-select-selection{
  height: 100%;
  display: flex;
  align-items: center;
  width: 120px;
}
/deep/.el-input__inner
{
  text-align: left;
  font-size: 12px;
  height:32px;
  line-height: 32px;
  &:-webkit-autofill {
    transition: background-color 99999s ease-in-out 0s !important;
    -webkit-text-fill-color: rgba(0, 0, 0, 0.85) !important;
  }
  // 自动填充文本样式
  &:-webkit-autofill::first-line {
    font-size: 12px;
  }
}
.space{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
